import { Component as e } from "react";
class n extends e {
  state = { error: null };
  static getDerivedStateFromError(r) {
    return { error: r };
  }
  componentDidCatch(r, t) {
    this.props.onError?.(r, t);
  }
  reset = () => {
    this.setState({ error: null });
  };
  render() {
    const { error: r } = this.state;
    if (r) {
      const { fallback: t } = this.props;
      return typeof t == "function" ? t(r, this.reset) : t;
    }
    return this.props.children;
  }
}
export {
  n as ErrorBoundary
};
//# sourceMappingURL=ErrorBoundary.js.map
